module.exports = __webpack_public_path__ + "static/EGH_MobxStateTree-7280375b65b2fa66c957cf8b2763993b.png";